import React, { useState } from "react";
import { MetricTypeConstants, metricUOM } from '../constants/MetricTypeConstrants';
import { formatDate } from "../helper/dateFormatter";

class MetricValue {
    value: number | undefined | string;
    secondaryValue: number | undefined;
    uom: string | undefined;
    secondaryUom: string | undefined;
    displayHTML: any | undefined;
}

interface LastUpdatedProps {
    lastUpdated?: string;
}

export const getValueWithUOM = (metricType: string, value: number) => {

    const metricValue = new MetricValue();
    if (metricType === MetricTypeConstants.HEIGHT) {
        const feet = Math.floor(value / 12);
        const inch = value % 12;

        metricValue.uom = metricUOM.get('P_' + metricType);
        metricValue.value = feet;
        metricValue.secondaryValue = inch;
        metricValue.secondaryUom = metricUOM.get('S_' + metricType);

    } else {
        metricValue.uom = metricUOM.get(metricType);
        metricValue.value = value;
    }
    metricValue.displayHTML = getDisplayValue(metricValue);
    return metricValue;
}

const getDisplayValue = (metricValue: MetricValue) => {
    return (
        <>
            <strong className='fs-18'>{metricValue.value} </strong>
            <span className='text-light fs-11 me-1'>{metricValue.uom} </span>

            {metricValue.secondaryValue && (<>
                <strong className='fs-18'>{metricValue.secondaryValue} </strong>
                <span className='text-light fs-11 me-1'>{metricValue.secondaryUom?.toLowerCase()} </span>
            </>
            )}
        </>
    );
}

export const getValueWithUOMForBP = (metricType: string, sys: number, dys: number) => {
    const metricValue = new MetricValue();
    metricValue.uom = metricUOM.get(metricType);
    metricValue.value = `${sys}/${dys}`;
    metricValue.displayHTML = getBPDisplayValue(metricValue);
    return metricValue;
}

const getBPDisplayValue = (metricValue: MetricValue) => {
    return (
        <>
            <strong className='fs-18'>{metricValue.value} </strong>
            <span className='text-light fs-11 me-1'>{metricValue.uom?.toLowerCase()} </span>
        </>
    );
}

export const LastUpdated: React.FC<LastUpdatedProps> = (props: LastUpdatedProps) => {
    return (<>
        { props.lastUpdated ? <div className="fs-11 text-light">Last Updated {formatDate(props.lastUpdated.toLocaleString())}</div> :
                <div className="fs-11 text-light">All time</div>
        }
    </>)
}